"use client";

import React, { useState } from "react";
import { Button } from "@/components/Button";
import { Modal } from "antd";
import ContactForm from "@/components/InquryForm/ContactForm";
import { useTranslations } from "next-intl";
import clsx from "clsx";

type Props = {
	size?: "xs" | "sm" | "md" | "lg" | "xl";
	className?: string;
	count: number;
	id: string;
	text?: string;
	VariantActive: any;
	product: any;
	locale: string;
	buttonText?: string;
};

export default function ModalInquiryButton({
	size = "md",
	className = "",
	count,
	id,
	text = "form.Inquiry Now",
	VariantActive,
	product,
	locale,
	buttonText,
}: Props) {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [loading, setLoading] = useState(false);
	const t = useTranslations();

	// 打开模态框
	const openModal = () => {
		if (!VariantActive) return;
		setIsModalOpen(true);
	};

	// 关闭模态框
	const closeModal = () => {
		setIsModalOpen(false);
	};

	// 获取产品图片
	const getProductImage = () => {
		if (!product?.media) return "/image/default-image.webp";
		try {
			const media = JSON.parse(product.media);
			return Array.isArray(media) && media.length > 0 ? (media[0] as any)?.url : "/image/default-image.webp";
		} catch (error) {
			console.error("Error parsing product media:", error);
			return "/image/default-image.webp";
		}
	};

	// 获取当前产品的询盘数据
	const getCurrentProductInquiry = () => {
		if (!product || !VariantActive) return [];

		return [
			{
				variant: {
					product: product,
					id: VariantActive.id,
					name: VariantActive.name,
				},
				name: product.name,
				slug: product.slug,
				quantity: count,
			},
		];
	};

	return (
		<>
			<Button
				disabled={VariantActive == null || loading}
				size={size}
				className={clsx(
					"relative !px-3 !py-2",
					(VariantActive == null || loading) && "!cursor-not-allowed opacity-50 hover:bg-main",
					className,
				)}
				onClick={openModal}
			>
				{loading ? (
					<div className="flex items-center justify-center gap-2">
						<svg
							className="h-4 w-4 animate-spin text-white"
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
						>
							<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
							<path
								className="opacity-75"
								fill="currentColor"
								d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
							/>
						</svg>
						<span>{t("nav.loading")}</span>
					</div>
				) : (
					buttonText || t(text)
				)}
			</Button>

			<Modal
				title={null}
				open={isModalOpen}
				onCancel={closeModal}
				footer={null}
				width={800}
				centered
				destroyOnClose
				className="modal-inquiry"
				styles={{
					body: {
						padding: 0,
					},
				}}
			>
				<div className="relative box-border !overflow-y-auto p-8">
					<h1 className="mb-3 text-2xl max-md:text-xl">{t("form.RequestAQuote")}</h1>

					{/* 显示询盘产品信息 */}
					{product && VariantActive && (
						<div className="mb-6 rounded-lg border border-gray-200 p-4">
							<h3 className="mb-2 text-lg font-medium">{t("product.InquiryProduct")}</h3>
							<div className="flex items-center gap-4">
								<div className="flex-shrink-0">
									<img
										src={getProductImage()}
										alt={product.name}
										className="h-16 w-16 rounded-md object-cover"
									/>
								</div>
								<div>
									<p className="font-medium">{product.name}</p>
									<p className="text-sm text-gray-500">
										{t("product.Variant")}: {VariantActive.name}
									</p>
									<p className="text-sm text-gray-500">
										{t("product.Quantity")}: {count}
									</p>
								</div>
							</div>
						</div>
					)}

					<ContactForm
						locale={locale}
						className="!py-0"
						inquiry={getCurrentProductInquiry()}
						source="product-modal-inquiry"
					/>
				</div>
			</Modal>
		</>
	);
}
